import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class ConceptsAdd extends Component{
	render(){
		const {concepts} =this.props;
		let cc = _.find(concepts.permissions, (o) => {return o==='Create'});
		return (
			cc ?
				<p>
					<NavLink to={`/gastos/conceptos/crear`} className="button is-small is-inm-purple">{'Agregar Concepto'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(ConceptsAdd);


// WEBPACK FOOTER //
// ./src/elements/concepts/widget/concepts_add.jsx